'use strict';
import { app } from '../../../../../bootstrap/core';

import standingOrderConflictModalController from './conflictModal.component';
import { StandingOrdersConflictModalService } from './conflictModal.service';

app.component(
  'standingOrderConflictModalComponent',
  standingOrderConflictModalController,
);

app.service(
  'standingOrderConflictModalService',
  StandingOrdersConflictModalService,
);
